import { ButtonProps } from '../types';

export const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  href,
  variant = 'primary',
  className = '',
  ariaLabel,
}) => {
  const baseStyles = 'inline-flex items-center justify-center font-bold font-mono transition-all duration-200 min-h-[44px] min-w-[44px] px-10 py-6';
  
  const variantStyles = {
    primary: 'bg-gorillaGold text-deepBlack hover:bg-[#E5C65A] rounded-lg shadow-[0_4px_14px_rgba(229,198,90,0.3)] hover:shadow-[0_6px_20px_rgba(229,198,90,0.5)]',
    secondary: 'bg-white/5 text-primary border border-borderGray hover:bg-white/10 rounded-lg',
  };

  const combinedClassName = `${baseStyles} ${variantStyles[variant]} ${className}`;

  if (href) {
    return (
      <a
        href={href}
        className={combinedClassName}
        aria-label={ariaLabel}
        target={href.startsWith('http') ? '_blank' : undefined}
        rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      onClick={onClick}
      className={combinedClassName}
      aria-label={ariaLabel}
      type="button"
    >
      {children}
    </button>
  );
};
